import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['savitarnaKrepselisUrl']),
  },
  methods: {
    editItem(item, routename = 'hipotekaPranesimas') {
      const objektasID = item.obj_id
      this.$store.dispatch('objektasID', objektasID)
      this.$store.dispatch('hipotekaTipas', item.pranesimo_rusis)
      this.$router.push({
        name: routename,
        params: {
          objektasID: objektasID,
        },
      })
    },
    savitarnaAction(item, veiksmas) {
      item.loading = true
      if (
        veiksmas.kodas.includes('redagavimas') ||
        veiksmas.kodas.includes('perziura')
      ) {
        this.editItem(item)
      }
      if (veiksmas.kodas.includes('salinimas')) {
        this.deleteItem(item)
      }
      if (veiksmas.kodas.includes('pasirasymas')) {
        this.editItem(item, 'hipotekaRegistravimas')
      }
      if (veiksmas.kodas.includes('pakeitimas')) {
        this.confirmPakeitimas(item, veiksmas.kodas)
      }
      if (veiksmas.kodas.includes('pabaiga')) {
        this.confirmPabaiga(item, veiksmas.kodas)
      }
      if (veiksmas.kodas.includes('pageidavimas')) {
        this.confirmPageidavimas(item, veiksmas.kodas)
      }
      if (veiksmas.kodas.includes('atsaukimas')) {
        this.confirmAtsaukimas(item, veiksmas.kodas)
      }
      if (veiksmas.kodas.includes('neisregistruoti')) {
        this.confirmNeisregistruoti(item, veiksmas.kodas)
      }
      if (veiksmas.kodas.includes('mokejimas')) {
        this.confirmMokejimas(item, veiksmas.kodas)
      }
    },
    sukurtiHipoteka(objektasTipas, dok_id = null) {
      const data = {
        obj_tipas: objektasTipas,
        dok_id: dok_id,
        vyk_id: null,
      }
      this.$axios
        .post(`objektas`, data)
        .then(res => {
          this.$store.dispatch('objektasID', res.data.objektas.obj_id)
          this.$store.dispatch('hipotekaTipas', objektasTipas)
          this.$store.dispatch('objektasVeiksmas', 0)
          this.$router.push({
            name: 'hipotekaPranesimas',
            params: {
              objektasID: res.data.objektas.obj_id,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.resetLoading()
        })
    },
    getPakeitimasTipas(veiksmasKodas) {
      if (veiksmasKodas.includes('hipoteka')) {
        return 'hipotekos'
      }
      if (veiksmasKodas.includes('ikeitimas')) {
        return 'įkeitimo'
      }
      if (veiksmasKodas.includes('sutartis')) {
        return 'sutarties'
      }
      return ''
    },
    getPabaigaTipas(veiksmasKodas) {
      if (veiksmasKodas.includes('hipoteka')) {
        return 'hipoteką'
      }
      if (veiksmasKodas.includes('ikeitimas')) {
        return 'įkeitimą'
      }
      if (veiksmasKodas.includes('sutartis')) {
        return 'sutartį'
      }
      return ''
    },
    confirmPakeitimas(item, veiksmasKodas) {
      this.modalConfirmTitle = 'Pakeitimas'
      this.modalConfirmText = `Ar tikrai norite kurti ${this.getPakeitimasTipas(
        veiksmasKodas
      )} <strong>${item.identifikavimo_kodas_registre ??
        ''}</strong> pakeitimą?`
      this.modalConfirmItem = Object.assign(
        {},
        { item: item, veiksmasKodas: veiksmasKodas }
      )
      this.showConfirm = true
    },
    confirmPabaiga(item, veiksmasKodas) {
      this.modalConfirmTitle = 'Išregistravimas'
      this.modalConfirmText = `Ar tikrai norite išregistruoti ${this.getPabaigaTipas(
        veiksmasKodas
      )} <strong>${item.identifikavimo_kodas_registre ?? ''}</strong>?`

      if (!item.yra_kreditorius && veiksmasKodas.includes('hipoteka')) {
        this.modalConfirmText += `<br />Hipoteka bus išregistruota:<br />
        <ul>
        <li>pasirašius prašymą;</li>
        <li>kreditoriui patvirtinus hipotekos pabaigą;</li>
        <li>sumokėjus už paslaugą.</li>
        </ul>
        Duomenų teisingumas patvirtinamas kvalifikuotu elektroniniu parašu.<br />
        Kreditorius apie laukiantį patvirtinimą informuojamas el. paštu, nurodykite teisingą kreditoriaus el. paštą.`
      }
      if (!item.yra_kreditorius && veiksmasKodas.includes('ikeitimas')) {
        this.modalConfirmText += `<br />Įkeitimas bus išregistruotas:
        <ul>
        <li>pasirašius prašymą;</li>
        <li>kreditoriui patvirtinus įkeitimo pabaigą;</li>
        <li>sumokėjus už paslaugą.</li>
        </ul>
        Duomenų teisingumas patvirtinamas kvalifikuotu elektroniniu parašu.<br />
        Kreditorius apie laukiantį patvirtinimą informuojamas el. paštu, nurodykite teisingą kreditoriaus el. paštą.`
      }
      this.modalConfirmItem = Object.assign(
        {},
        { item: item, veiksmasKodas: veiksmasKodas }
      )
      this.showConfirm = true
    },
    confirmPageidavimas(item, veiksmasKodas) {
      this.modalConfirmTitle = 'Pageidavimas pasinaudoti atpirkimo teise'
      this.modalConfirmText = `Ar tikrai norite kurti sutarties <strong>${item.identifikavimo_kodas_registre ??
        ''}</strong> pakeitimą?`
      this.modalConfirmItem = Object.assign(
        {},
        { item: item, veiksmasKodas: veiksmasKodas }
      )
      this.showConfirm = true
    },
    confirmAtsaukimas(item, veiksmasKodas) {
      this.modalConfirmTitle =
        'Pageidavimo pasinaudoti atpirkimo teise atšaukimas'
      this.modalConfirmText = `Ar tikrai norite kurti sutarties <strong>${item.identifikavimo_kodas_registre ??
        ''}</strong> pakeitimą?`
      this.modalConfirmItem = Object.assign(
        {},
        { item: item, veiksmasKodas: veiksmasKodas }
      )
      this.showConfirm = true
    },
    confirmNeisregistruoti(item, veiksmasKodas) {
      this.modalConfirmTitle = 'Prašymas neišregistruoti sutarties automatiškai'
      this.modalConfirmText = `Ar tikrai norite kurti sutarties <strong>${item.identifikavimo_kodas_registre ??
        ''}</strong> pakeitimą?`
      this.modalConfirmItem = Object.assign(
        {},
        { item: item, veiksmasKodas: veiksmasKodas }
      )
      this.showConfirm = true
    },
    confirmMokejimas(item, veiksmasKodas) {
      this.loading = true
      const data = { obj_id: item.obj_id }

      this.$axios
        .post(`objektas/${item.obj_id}/busena/apmoketas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
          } else {
            this.loading = false
            this.resetLoading()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
          this.resetLoading()
        })
    },
    gotoKrepselis(krepselis_id = null) {
      if (krepselis_id) {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${krepselis_id}`
        return
      }
      window.location.href = this.savitarnaKrepselisUrl
    },
    confirmConfirm(confirmItem) {
      let { item, veiksmasKodas } = confirmItem

      if (veiksmasKodas.includes('pakeitimas')) {
        this.sukurtiHipoteka(`${item.pranesimo_saknis}-pakeitimas`, item.dok_id)
      }
      if (veiksmasKodas.includes('pabaiga')) {
        this.sukurtiHipoteka(`${item.pranesimo_saknis}-pabaiga`, item.dok_id)
      }
      if (veiksmasKodas.includes('pageidavimas')) {
        this.sukurtiHipoteka(
          `${item.pranesimo_saknis}-pageidavimas`,
          item.dok_id
        )
      }
      if (veiksmasKodas.includes('atsaukimas')) {
        this.sukurtiHipoteka(`${item.pranesimo_saknis}-atsaukimas`, item.dok_id)
      }
      if (veiksmasKodas.includes('neisregistruoti')) {
        this.sukurtiHipoteka(
          `${item.pranesimo_saknis}-neisregistruoti`,
          item.dok_id
        )
      }
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.dokumento_numeris ?? ''
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`objektas/${item.obj_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.resetLoading()
    },
    resetLoading() {
      this.pranesimai = this.pranesimai.map(pranesimas => {
        pranesimas.loading = false
        return pranesimas
      })
    },
  },
}
